import { get, put, del } from '@/lib/api/client'
import type { ApiResponse, AdminUser, UpdateAdminUserRequest } from '@/lib/api/types'

// Type for the profile API response (flat user objects in array)
export type ProfileApiResponse = Array<{
  userId: string
  firstName: string
  lastName: string
  emailAddress: string
  profileImageUrl?: string | null
  isDefaultPassword?: boolean
  userRole?: string
  otpChannel?: string
  hasActivatedAccount?: boolean
  isTwoFactorEnabled?: boolean
  joinDate?: string
}>

export const adminUserService = {
  // Get all admin users
  getAllAdminUsers: async (): Promise<ApiResponse<AdminUser[]>> => {
    return await get<ApiResponse<AdminUser[]>>('admins/private/all')
  },

  // Get current user profile (real-time data from API)
  // Endpoint: GET /api/v1/admins/private/profile
  // Returns array of users, we need to find the current user by userId
  getCurrentUserProfile: async (): Promise<ApiResponse<ProfileApiResponse>> => {
    return await get<ApiResponse<ProfileApiResponse>>('admins/private/profile')
  },

  // Update admin user profile
  updateAdminUser: async (
    data: UpdateAdminUserRequest
  ): Promise<ApiResponse<AdminUser>> => {
    return await put<ApiResponse<AdminUser>>('admins/private/profile', data)
  },

  // Toggle account status (block/unblock)
  toggleAccountStatus: async (
    userId: string,
    blockStatus: boolean
  ): Promise<ApiResponse<AdminUser>> => {
    return await put<ApiResponse<AdminUser>>(
      `admins/private/toggle-account-status/${userId}?blockStatus=${blockStatus}`,
      {}
    )
  },

  // Delete admin user
  deleteAdminUser: async (
    userId: string,
    deleteStatus: boolean
  ): Promise<ApiResponse<void>> => {
    return await del<ApiResponse<void>>(
      `admins/private/delete-admin/${userId}?deleteStatus=${deleteStatus}`
    )
  },

  // Change password for current authenticated admin
  changePassword: async (
    data: { oldPassword: string; newPassword: string }
  ): Promise<ApiResponse<null>> => {
    return await put<ApiResponse<null>>('admins/private/change-password', data)
  }
}

